export type Language = "fr" | "de" | "en";

export const TRANSLATIONS: Record<string, Record<Language, string>> = {
  // Navigation
  "nav.home": {
    fr: "Accueil",
    de: "Startseite",
    en: "Home",
  },
  "nav.repairs": {
    fr: "Réparations",
    de: "Reparaturen",
    en: "Repairs",
  },
  "nav.buy": {
    fr: "Acheter",
    de: "Kaufen",
    en: "Buy",
  },
  "nav.sell": {
    fr: "Revendre",
    de: "Verkaufen",
    en: "Sell",
  },
  "nav.accessories": {
    fr: "Accessoires",
    de: "Zubehör",
    en: "Accessories",
  },
  "nav.blog": {
    fr: "Blog Tech",
    de: "Tech-Blog",
    en: "Tech Blog",
  },
  "nav.find_model": {
    fr: "Identifier",
    de: "Gerät finden",
    en: "Find Model",
  },
  "nav.diagnostic": {
    fr: "Diagnostic",
    de: "Diagnose",
    en: "Diagnostic",
  },
  "nav.contact": {
    fr: "Contact",
    de: "Kontakt",
    en: "Contact",
  },

  // Global Search
  "search.placeholder": {
    fr: "Rechercher un modèle de téléphone...",
    de: "Nach Telefonmodell suchen...",
    en: "Search for a phone model...",
  },
  "search.models": {
    fr: "Modèles de téléphones",
    de: "Telefonmodelle",
    en: "Phone Models",
  },
  "search.accessories": {
    fr: "Accessoires correspondants",
    de: "Passendes Zubehör",
    en: "Matching Accessories",
  },
  "search.repairs": {
    fr: "Réparations disponibles",
    de: "Verfügbare Reparaturen",
    en: "Available Repairs",
  },

  // Cart / Purchase Action Labels
  "cart.add": {
    fr: "Ajouter au panier",
    de: "In den Warenkorb",
    en: "Add to Cart",
  },
  "cart.on_request": {
    fr: "Commander sur demande",
    de: "Auf Anfrage bestellen",
    en: "Order on Request",
  },
  "cart.in_stock": {
    fr: "En stock",
    de: "Auf Lager",
    en: "In Stock",
  },
  "cart.out_of_stock": {
    fr: "Rupture de stock",
    de: "Ausverkauft",
    en: "Out of Stock",
  },
  "cart.title": {
    fr: "Votre Panier",
    de: "Ihr Warenkorb",
    en: "Your Cart",
  },
  "cart.empty": {
    fr: "Votre panier est vide",
    de: "Ihr Warenkorb ist leer",
    en: "Your cart is empty",
  },
  "cart.checkout": {
    fr: "Passer la commande",
    de: "Zur Kasse gehen",
    en: "Proceed to Checkout",
  },
  "cart.total": {
    fr: "Total",
    de: "Gesamtsumme",
    en: "Total",
  },

  // Common Buttons & Interactive Labels
  "btn.next": {
    fr: "Suivant",
    de: "Weiter",
    en: "Next",
  },
  "btn.back": {
    fr: "Retour",
    de: "Zurück",
    en: "Back",
  },
  "btn.confirm": {
    fr: "Confirmer",
    de: "Bestätigen",
    en: "Confirm",
  },
  "btn.cancel": {
    fr: "Annuler",
    de: "Abbrechen",
    en: "Cancel",
  },
  "btn.contact_us": {
    fr: "Contactez-nous",
    de: "Kontaktieren Sie uns",
    en: "Contact Us",
  },
  "btn.book_appointment": {
    fr: "Prendre un rendez-vous",
    de: "Termin buchen",
    en: "Book an Appointment",
  },

  // Repairs Page
  "repairs.title": {
    fr: "Réparation de votre Smartphone",
    de: "Smartphone Reparatur",
    en: "Smartphone Repair",
  },
  "repairs.subtitle": {
    fr: "Sélectionnez votre appareil pour demander une estimation et prendre rendez-vous.",
    de: "Wählen Sie Ihr Gerät aus und erhalten Sie ein sofortiges Angebot mit Terminbuchung.",
    en: "Select your device and get an instant quote with appointment booking.",
  },
  "repairs.brand_step": {
    fr: "1. Choisissez la marque",
    de: "1. Marke auswählen",
    en: "1. Select Brand",
  },
  "repairs.model_step": {
    fr: "2. Choisissez le modèle",
    de: "2. Modell auswählen",
    en: "2. Select Model",
  },
  "repairs.repair_step": {
    fr: "3. Choisissez vos réparations",
    de: "3. Reparaturen auswählen",
    en: "3. Select Repairs",
  },
  "repairs.duration": {
    fr: "Durée estimée",
    de: "Geschätzte Dauer",
    en: "Estimated Duration",
  },
  "repairs.price": {
    fr: "Tarif",
    de: "Preis",
    en: "Price",
  },

  // Buy Phone Page / Store Catalog
  "buy.title": {
    fr: "Acheter un Smartphone Reconditionné",
    de: "Refurbished Smartphone kaufen",
    en: "Buy Refurbished Smartphone",
  },
  "buy.subtitle": {
    fr: "Des téléphones avec état, prix et conditions publiés, livrés chez vous en Suisse.",
    de: "Premium-Qualitätstelefone, getestet und garantiert, zu Ihnen in die Schweiz geliefert.",
    en: "Premium quality phones, tested and guaranteed, delivered to your door in Switzerland.",
  },
  "buy.filters": {
    fr: "Filtres",
    de: "Filter",
    en: "Filters",
  },
  "buy.warranty_info": {
    fr: "Garantie incluse",
    de: "Garantie enthalten",
    en: "Warranty Included",
  },

  // Sell Phone Page (Rachat)
  "sell.title": {
    fr: "Revendre votre Smartphone",
    de: "Verkaufen Sie Ihr Smartphone",
    en: "Sell Your Smartphone",
  },
  "sell.subtitle": {
    fr: "Estimez la valeur de rachat de votre téléphone en 3 clics et recevez un virement rapide.",
    de: "Schätzen Sie den Wert Ihres Telefons in 3 Klicks und erhalten Sie eine schnelle Auszahlung.",
    en: "Estimate your phone trade-in value in 3 clicks and get paid fast.",
  },
  "sell.form_customer_info": {
    fr: "Vos Informations Personnelles",
    de: "Ihre persönlichen Daten",
    en: "Your Personal Info",
  },

  // Contact Page
  "contact.title": {
    fr: "Contactez notre Boutique",
    de: "Kontaktieren Sie unseren Shop",
    en: "Contact Our Shop",
  },
  "contact.form_title": {
    fr: "Envoyez-nous un Message",
    de: "Senden Sie uns eine Nachricht",
    en: "Send Us a Message",
  },
  "contact.field_name": {
    fr: "Nom",
    de: "Name",
    en: "Name",
  },
  "contact.field_email": {
    fr: "E-mail",
    de: "E-Mail",
    en: "Email",
  },
  "contact.field_phone": {
    fr: "Téléphone",
    de: "Telefon",
    en: "Phone",
  },
  "contact.field_message": {
    fr: "Message",
    de: "Nachricht",
    en: "Message",
  },
};

export function getTranslation(
  language: Language,
  key: string,
  defaultText?: string,
): string {
  if (TRANSLATIONS[key] && TRANSLATIONS[key][language]) {
    return TRANSLATIONS[key][language];
  }
  return defaultText !== undefined ? defaultText : key;
}
